import React from 'react';
import styled from 'styled-components';
import { TicTacToe } from '../TicTacToe';

/* ── Styled components ───────────────────────────────────────── */
const FooterWrap = styled.div`
    max-width: 1200px;
    margin: var(--space-4) auto var(--space-8);
    padding: 0 var(--space-6);
    transition: max-width 0.85s cubic-bezier(0.16, 1, 0.3, 1);

    body.ab-expanded & {
        max-width: 1360px;
    }
`;

const FooterCard = styled.div`
    background: ${({ theme }) => theme.altWhite};
    border-radius: var(--radius-xl);
    padding: 44px 52px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: var(--space-12);

    @media (max-width: 768px) {
        flex-direction: column;
        padding: var(--space-8) var(--space-6);
        gap: var(--space-9);
    }
`;

const ColGroup = styled.div`
    display: flex;
    gap: 72px;
    flex-shrink: 0;

    @media (max-width: 480px) {
        gap: 40px;
    }
`;

const Col = styled.div``;

const ColTitle = styled.h4`
    font-size: 20px;
    letter-spacing: -0.4px;
    margin: 0 0 var(--space-5);
`;

const LinkList = styled.div`
    display: flex;
    flex-direction: column;
    gap: var(--space-3);
`;

const FooterLink = styled.a`
    font-family: var(--font-body);
    font-size: 16px;
    font-weight: 400;
    color: var(--color-text-secondary);
    text-decoration: none;
    transition: color 0.15s ease;

    &:hover { color: var(--color-heading); }
`;

/* ── Data ────────────────────────────────────────────────────── */
const NAV_LINKS = [
    { label: 'Recent work', href: '/#case-studies' },
    { label: 'Talks',       href: '/#talks'        },
    { label: 'About me',    href: '/about'          },
    { label: 'Contact',     href: 'mailto:kimanigodfrey4@gmail.com' },
];

const SITE_LINKS = [
    { label: 'LinkedIn', href: 'https://www.linkedin.com/in/kimanigodfrey/',                              external: true },
    { label: 'Resume',   href: 'https://drive.google.com/file/d/1-8upvByq1Y7xDEjyoqYdwfX_2YTB80VT/view?usp=drive_link', external: true },
];

/* ── Component ───────────────────────────────────────────────── */
const SiteFooter = () => (
    <FooterWrap>
        <FooterCard>
            {/* Left: game */}
            <div id="game" style={{ flexShrink: 0 }}>
                <TicTacToe />
            </div>

            {/* Right: nav columns */}
            <ColGroup>
                <Col>
                    <ColTitle>Navigation</ColTitle>
                    <LinkList>
                        {NAV_LINKS.map(({ label, href }) => (
                            <FooterLink key={label} href={href}>{label}</FooterLink>
                        ))}
                    </LinkList>
                </Col>

                <Col>
                    <ColTitle>Links</ColTitle>
                    <LinkList>
                        {SITE_LINKS.map(({ label, href, external }) => (
                            <FooterLink
                                key={label}
                                href={href}
                                target={external ? '_blank' : undefined}
                                rel={external ? 'noopener noreferrer' : undefined}
                            >
                                {label}
                            </FooterLink>
                        ))}
                    </LinkList>
                </Col>
            </ColGroup>
        </FooterCard>
    </FooterWrap>
);

export { SiteFooter };
